export default {"src":"/_next/static/media/Email--Streamline-Ios-14.7b8fadb7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};